import {
  GET_MARKETING_PROMOTION_LIST,
  GET_MARKETING_PROMOTION_LIST_SUCCESS,
  GET_MARKETING_PROMOTION_LIST_FAILED,
  GET_MARKETING_PROMOTION_DETAIL,
  GET_MARKETING_PROMOTION_DETAIL_SUCCESS,
  GET_MARKETING_PROMOTION_DETAIL_FAILED,
  CREATE_MARKETING_PROMOTION,
  CREATE_MARKETING_PROMOTION_SUCCESS,
  CREATE_MARKETING_PROMOTION_FAILED,
  UPDATE_MARKETING_PROMOTION,
  UPDATE_MARKETING_PROMOTION_SUCCESS,
  UPDATE_MARKETING_PROMOTION_FAILED,
  DELETE_MARKETING_PROMOTION,
  DELETE_MARKETING_PROMOTION_SUCCESS,
  DELETE_MARKETING_PROMOTION_FAILED,
} from './actionTypes';

const initialState = {
  isLoadingGetMarketingPromotionList: false,
  isLoadingGetMarketingPromotionDetail: false,
  isLoadingCreateMarketingPromotion: false,
  isLoadingUpdateMarketingPromotion: false,
  isLoadingDeleteMarketingPromotion: false,
  marketingPromotionList: [],
  marketingPromotionTotal: 0,
  marketingPromotionDetail: null,
};

export default function managerPromotion(state = initialState, action) {
  switch (action.type) {
    case GET_MARKETING_PROMOTION_LIST:
      return {
        ...state,
        isLoadingGetMarketingPromotionList: true,
      };

    case GET_MARKETING_PROMOTION_LIST_SUCCESS: {
      const data = action.payload?.data || [];
      const total = action.payload?.total ?? data.length;

      return {
        ...state,
        isLoadingGetMarketingPromotionList: false,
        marketingPromotionList: data,
        marketingPromotionTotal: total,
      };
    }

    case GET_MARKETING_PROMOTION_LIST_FAILED:
      return {
        ...state,
        isLoadingGetMarketingPromotionList: false,
      };

    case GET_MARKETING_PROMOTION_DETAIL:
      return {
        ...state,
        isLoadingGetMarketingPromotionDetail: true,
      };

    case GET_MARKETING_PROMOTION_DETAIL_SUCCESS:
      return {
        ...state,
        isLoadingGetMarketingPromotionDetail: false,
        marketingPromotionDetail: action.payload || null,
      };

    case GET_MARKETING_PROMOTION_DETAIL_FAILED:
      return {
        ...state,
        isLoadingGetMarketingPromotionDetail: false,
      };

    case CREATE_MARKETING_PROMOTION:
      return {
        ...state,
        isLoadingCreateMarketingPromotion: true,
      };

    case CREATE_MARKETING_PROMOTION_SUCCESS:
    case CREATE_MARKETING_PROMOTION_FAILED:
      return {
        ...state,
        isLoadingCreateMarketingPromotion: false,
      };

    case UPDATE_MARKETING_PROMOTION:
      return {
        ...state,
        isLoadingUpdateMarketingPromotion: true,
      };

    case UPDATE_MARKETING_PROMOTION_SUCCESS:
    case UPDATE_MARKETING_PROMOTION_FAILED:
      return {
        ...state,
        isLoadingUpdateMarketingPromotion: false,
      };

    case DELETE_MARKETING_PROMOTION:
      return {
        ...state,
        isLoadingDeleteMarketingPromotion: true,
      };

    case DELETE_MARKETING_PROMOTION_SUCCESS:
    case DELETE_MARKETING_PROMOTION_FAILED:
      return {
        ...state,
        isLoadingDeleteMarketingPromotion: false,
      };

    default:
      return state;
  }
}
